import { useEffect } from "react";
import * as E from "@numi/engine";
import { S, useApp, touch } from "../store.ts";
import { Card, Html, Icon, Numi } from "../ui.tsx";
import { SFX, canSpeak, speak } from "../sound.ts";
import { startTry, sayAloud, roundLen } from "../question.ts";
import { QuestionView, tapCount } from "./Question.tsx";

function Steps({ n, step }: { n: number; step: number }) {
  return <div className="steps" aria-label={`Step ${Math.min(step, n) + 1} of ${n + 1}`}>{Array.from({ length: n + 1 }, (_, i) => <i key={i} className={`${i <= step ? "on" : ""} ${i === n ? "try" : ""}`} />)}</div>;
}
export function Learn() {
  const s = useApp(); const t = E.topic(s.topic!)!; const n = t.lesson.length; const inTry = s.step >= n;
  const say = inTry ? "" : E.stepText(t.lesson[s.step].say);
  useEffect(() => {
    if (inTry) { if (!S.qs || S.qs.ctx !== "try") startTry(); return; }
    const key = `${t.id}#${s.step}`; if (s.spokenKey !== key) { s.spokenKey = key; setTimeout(() => sayAloud(say), 250); }
  }, [s.step, t.id, inTry]);
  if (inTry) return <main><Card className="stage"><div className="row between"><h2 style={{ fontSize: "1.6rem" }}>Your turn</h2><Steps n={n} step={s.step} /></div>{s.qs && s.qs.ctx === "try" && <QuestionView />}</Card></main>;
  const st = t.lesson[s.step];
  return <main><Card className="stage">
    <div className="row between"><h2 style={{ fontSize: "1.6rem" }}>{E.topicTitle(t)}</h2><Steps n={n} step={s.step} /></div>
    <Html key={`${t.id}-${s.step}`} className="vizbox" html={st.viz()} onClick={tapCount} />
    {(s.child?.grade ?? 3) <= 2 && <span className="taphint"><Icon name="hand" /> Tap the pictures to count them.</span>}
    <div className="say"><Numi size={64} /><div className="speech">{say}</div>{canSpeak && <button className="round saybtn" aria-label="Read to me" onClick={() => speak(say, s.child?.board)}><Icon name="speak" /></button>}</div>
    <div className="row between">
      <button className="btn" disabled={s.step === 0} aria-label="Back a step" onClick={() => { s.step--; SFX.tap(); touch(); }}><Icon name="prev" /></button>
      <button className="btn yellow big" onClick={() => { s.step++; SFX.tap(); if (s.step >= n) S.qs = null; touch(); }}>{s.step < n - 1 ? "Next" : "Your turn"} <Icon name="next" /></button>
    </div>
  </Card></main>;
}
export function Practice() {
  const s = useApp(); const R = s.round!; const qs = s.qs!; const ROUND = roundLen();
  return <main><Card className="stage">
    <div className="qbar" aria-label={`Question ${Math.min(R.n + (qs.done ? 0 : 1), ROUND)} of ${ROUND}`}>{Array.from({ length: ROUND }, (_, i) => <i key={i} className={R.marks[i] || (i === R.n && !qs.done ? "now" : "")} />)}</div>
    <QuestionView />
  </Card></main>;
}
